import { focusRing } from '@florencelabs/fabric-styles';
import { tv } from 'tailwind-variants';

// Styles
export const fieldBorderStyles = tv({
  variants: {
    isFocusWithin: {
      false: 'border-gray-300  forced-colors:border-[red]',
      true: 'border-gray-600  forced-colors:border-[red]',
    },
    isInvalid: {
      true: 'border-red-600 forced-colors:border-[red]',
    },
    isDisabled: {
      true: 'border-gray-200  forced-colors:border-[red]',
    },
  },
});

export const fieldGroupStyles = tv({
  extend: focusRing,
  base: 'group flex items-center h-6  forced-colors:bg-[Field] border-2 rounded-lg overflow-hidden',
  variants: fieldBorderStyles.variants,
});
